// extracted by mini-css-extract-plugin
export var header = "_vv-1";
export var maskBottom = "_vv-6";
export var maskMiddle = "_vv-7";
export var maskTop = "_vv-5";
export var root = "_vv-0";
export var scrollDownButton = "_vv-3";
export var scrollDownButtonHidden = "_vv-4";
export var viewport = "_vv-2";